export default "__VITE_PUBLIC_ASSET__ad88d0af__"